const CONSTANTS = {
  APIKEY: `AIzaSyAF5KrabTQ0CSz5YUsUPyosYFXdZDiXrsw`,
  IPKEY: `5itbi169dldd1f`,
};

export default CONSTANTS;
